import { none } from 'fp-ts/lib/Option';
import { TApplicationState } from '../../models/application-state';
import { TUser } from '../../models/user.model';
import { AppAction } from './app.action';
import { APP_ADVISOR, APP_ADVISOR_KEY, APP_LOADING, APP_APPLICATION_STATE, APP_SPINNER } from './app.constant';

export type AppContextState = {
	isAppLoaded: boolean;
	showSpinner: boolean;
	advisorKey: string;
	user: TUser;
	applicationState: TApplicationState;
	loadUser: (user: TUser) => void;
	loadApplicationState: (appState: TApplicationState) => void;
	setShowSpinner: (show: boolean) => void;
};

export const initialState: AppContextState = {
	isAppLoaded: false,
	showSpinner: false,
	advisorKey: '',
	user: {
		defaultRole: none,
		isImpersonated: none,
		roles: [],
		userID: none,
		firstName: none,
		lastName: none,
		middleName: none,
		preferredName: none,
	},
	applicationState: {
		investorStrategyId: none,
        investorId: none,
        goalId: none,
        lastPageVisited: none,
        feeId: none,
        wordMark: none,
        advisorLogo: none,
        isLogoPreferred: none,
        agentId: none,
		agentName: none,
        companyName: none,
        isDiscretionary: none,
        customProposalIntroductionText: none,
		channelRequireGfamSuitability: none,
        defaultIntroductionText: none,
		address: none,
		phoneNumber: none,
        advisorPhoto: none,
	},
	loadUser: (user: TUser) => {},
	loadApplicationState: (appState: TApplicationState) => {},
	setShowSpinner: (show: boolean) => {}
};

export function appContextReducer(state: AppContextState, action: AppAction) {
	switch (action.type) {
		case APP_LOADING: {
			return {
				...state,
				isAppLoaded: action.payload,
			};
		}
		case APP_ADVISOR_KEY: {
			return {
				...state,
				advisorKey: action.payload,
			};
		}
		case APP_ADVISOR: {
			return {
				...state,
				isAppLoaded: true,
				user: action.payload,
			};
		}
		case APP_APPLICATION_STATE: {
			return {
				...state,
				isAppLoaded: true,
				applicationState: action.payload,
			};
		}
		case APP_SPINNER: {
			return {
				...state,
				showSpinner: action.payload,
			};
		}
		default: {
			throw new Error(`Unhandled action type: ${action}`);
		}
	}
}
